var ImageIcon = require("components/utility/icons/ImageIcon");

require("utility/feedback_override_display.scss");

var FeedbackOverrideDisplay = function(props) {
	var height = props.height || 30;
	var fontSize = height * 0.7;
	var top = height * 0.07;

	var style = props.style || {};
	style["fontSize"] = fontSize;

	var className = props.className || "";
	className += " feedbackOverrideDisplay";
	return (
		<span className={ className } style={ style }>
			<ImageIcon icon="reviews" style={{ width: height, height: height }} />
			<span className="overrideStar" style={{ top: top }}></span>
		</span>
	);
};

FeedbackOverrideDisplay.propTypes = StrictPropTypes({

	// Height in pixels
	height: PropTypes.number,

	className: PropTypes.string,

	// CSS style object for the text
	style: PropTypes.object
});

module.exports = FeedbackOverrideDisplay;



// WEBPACK FOOTER //
// ./modules/components/utility/FeedbackOverrideDisplay.js